import { all, fork } from 'redux-saga/effects';

import { sagas as contractLinkCreateSagas } from '@app/features/contractLink/contractLinkCreate';
import { sagas as externalDocumentSagas } from '@app/features/externalDocument';
import { sagas as embeddedDocumentSagas } from '@app/features/integration/embeddedDocument';
import subscriptionSagas from '@app/features/subscription/sagas';

import customBrandSettingSaga from '../features/customBrandSetting/sagas';
import accountSagas from './account/sagas';
import analyticsSagas from './analytics/sagas';
import bulkRequestSagas from './bulkRequest/sagas';
import contractAuthenticationSagas from './contract-authentication/sagas';
import contractProgressSagas from './contract-progress/sagas';
import contractSetupSagas from './contract-setup/sagas';
import documentSagas from './document/sagas';
import documentProgressSagas from './documentProgress/sagas';
import documentsSagas from './documents/sagas';
import documentsExportSagas from './documentsExport/sagas';
import editingDocumentSagas from './editingDocument/sagas';
import editingDocumentsSagas from './editingDocuments/sagas';
import participantSagas from './participant/sagas';
import requesterLinkSaga from './requesterLink/sagas';
import signingProgressInformationSagas from './signingProgressInformation/sagas';
import softLandingSagas from './softLanding/sagas';
import templateSagas from './template/sagas';
import userSagas from './user/sagas';
import userpilotSagas from './userpilot/sagas';

function* rootSaga() {
  yield all([
    fork(accountSagas),
    fork(analyticsSagas),
    fork(bulkRequestSagas),
    fork(contractAuthenticationSagas),
    fork(contractLinkCreateSagas),
    fork(contractProgressSagas),
    fork(contractSetupSagas),
    fork(customBrandSettingSaga),
    fork(embeddedDocumentSagas),
    fork(documentProgressSagas),
    fork(documentSagas),
    fork(documentsSagas),
    fork(documentsExportSagas),
    fork(editingDocumentSagas),
    fork(editingDocumentsSagas),
    fork(externalDocumentSagas),
    fork(participantSagas),
    fork(requesterLinkSaga),
    fork(signingProgressInformationSagas),
    fork(softLandingSagas),
    fork(subscriptionSagas),
    fork(templateSagas),
    fork(userSagas),
    fork(userpilotSagas),
  ]);
}

export default rootSaga;
